module.exports = __webpack_public_path__ + "img/Metastasis-BRCA_10X_DCIS.8ebc3fb4.png";